import { navigate, routes, useCurrentUrl } from "../../lib/urls";

export function useSpaceDrilldown(panelKey: string) {
  const {
    panel,
    space,
    search: searchParam,
  } = useCurrentUrl(routes.monitoring.workflows);
  const search = searchParam ?? "";

  return {
    open: panel === panelKey,
    selectedSpaceId: space ?? null,
    search,
    setSearch: (value: string) =>
      navigate(
        routes.monitoring.workflows,
        { search: value },
        { replace: true }
      ),
    close: () =>
      navigate(
        routes.monitoring.workflows,
        { panel: "", space: "", search: "" },
        { replace: true }
      ),
  };
}
